<template>
  <b-card class="chat-message">
    <span class="time">{{message.time_stamp | getMomentStr}}</span><br>
    <b-card-text class="description">
      <player-link :playerId="message.user_id" /> asks for life.
    </b-card-text>
    <b-progress :max="5" show-value>
      <b-progress-bar :value="message.counter" :label="label" :class="getProgressBarClass"></b-progress-bar>
    </b-progress>
  </b-card>
</template>

<script>
import PlayerLink from '../PlayerLink.vue';

export default {
  name: 'MessageMemberJoined',

  components: {
    PlayerLink,
  },

  props: {
    message: {
      type: Object,
      required: true,
    }
  },

  computed: {
    label() {
      const counter = this.message.counter;
      return counter.toString() + '/5';
    },

    getProgressBarClass() {
      return {
        empty: this.message.counter === 0,
      };
    },
  },
};
</script>

<style scoped>
  .description {
    margin-bottom: 0.2em;
  }

  .empty {
    color: black;
  }
</style>
